import { configureStore } from '@reduxjs/toolkit';

import configuratorSlice from './configurator-slice';

const store = configureStore({
  reducer: { 
    configurator: configuratorSlice.reducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  })
});

export default store;